import axios from 'axios';
import { buildPath } from './Base.api';

export function* resetEmail(data) {
    const url = buildPath(`/confirm-new-email/${data}`);
    return yield axios.get(url);
}
